import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

@Injectable()
export class DataService {

    constructor(private http: Http ) { }

    public getJSON(url:string): Observable<any> {
        return this.http.get(url)
            .map((res: any) => res.json())
            .catch((error: any) => { console.log(error); return Observable.throw(error.json); });

    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/base/config/data.service.ts